<template>
	<div>

		<template v-if="headerShow">
			<div class="society">
				<div class="societyTil">
					{{$t('发布')}}
				</div>
				<div class="societyAll">
					<div class="societyAllLeft">
						{{$t('岗位信息')}}（共{{allNum}}个）
					</div>
					<div class="societyAllRight">
						<div>已选 {{function_type.length+city_id.length+(keywords?1:0)}} 条件 | {{allNum}} 结果 | <span
								@click="goClear" style="cursor: pointer;">清除</span></div>
						<div>
							<span @click="goClear" style="cursor: pointer;"><i class="el-icon-circle-close"></i></span>
						</div>
					</div>
				</div>
				<div class="societySs">
					<div class="societySsOne">
						<input v-model="keywords" :placeholder="$t('工作职责')" />
					</div>
					<div class="societySsTwo" @click="goSs">{{$t('任职资格')}}</div>
				</div>
				<div class="societyXl">
					<div class="societyXlOne">
						<el-select v-model="function_type" multiple :placeholder="$t('地理位置')" @change="goSs">
							<el-option v-for="item in funList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="societyXlTwo">
						<el-select v-model="city_id" :placeholder="$t('澳华内镜')" multiple @change="goSs">
							<el-option v-for="item in cityList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="societyList">
					<div class="societyListFor" v-for="(item,index) in recruitList" :key="index"
						@click="goDetail(item)">
						<div class="societyListForOne">
							<div class="jiBox" v-if="item.is_urgent==1">
								<span class="ji">{{$t('投递操作')}}</span>
							</div>
							{{item.name}}
						</div>
						<div class="societyListForTwo">
							{{item.city_name}}｜{{item.function_type_name}}｜{{item.create_time}}{{item.is_my==1?' | 面议':' | '+(item.min_salary||'--')+'~'+(item.max_salary||'--')+'*'+(item.work_month||'--')}}{{item.education?" | "+item.education:''}}
						</div>
					</div>
				</div>
				<div class="newsPagination ">
					<el-pagination :page-size="limit" layout="prev, pager, next" :total="allNum"
						@current-change="goPagin">
					</el-pagination>
					<!-- <div class="newsPaginationFor" v-for="(item,index) in allArr" :key="index" @click="goPagin(item)">
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
							v-if="index==0">
							{{$t('上传')}}
						</div>
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
							v-else-if="index==(allArr - 1)">
							{{$t('上传简历')}}
						</div>
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationFour':'newsPaginationTwo'"
							v-else>
							{{item}}
						</div>
					</div> -->
				</div>
				<div class="zxzw">
					<div class="zxzwTil">{{$t('上传简历')}}</div>
					<div class="zxzwList">
						<div class="zxzwListFor" v-for="(item,index) in newPosition" :key="index"
							@click="goDetail(item)">
							{{item.name}}
						</div>
					</div>
				</div>
				<!-- <div class="societyTilTwo">
					{{$t('支持')}}
				</div> -->
				<div class="societyTilTwoCen">
					{{$t('等简历格式')}}：{{email}}
				</div>
			</div>

		</template>
		<template v-else>
			<div class="society">
				<div class="societyTil">
					{{$t('上传附件')}}
				</div>
				<div class="societyAll">
					<div class="societyAllLeft">
						{{$t('上传附件')}}（共{{allNum}}个）
					</div>
					<div class="societyAllRight">
						<div class="societyAllRightInfo">
							<div>已选 {{function_type.length+city_id.length+(keywords?1:0)}} 条件 | {{allNum}} 结果 | </div>
							<div @click="goClear" style="cursor: pointer;" class="clearBtn">
								清除
								<div>
									<span @click="goClear" style="cursor: pointer;"><i
											class="el-icon-circle-close"></i></span>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="societySs">
					<div class="societySsOne">
						<input v-model="keywords" :placeholder="$t('个人信息')" />
					</div>
					<div class="societySsTwo" @click="goSs">{{$t('姓名')}}</div>
				</div>
				<div class="societyXl">
					<div class="societyXlOne">
						<el-select v-model="function_type" multiple :placeholder="$t('姓名')" @change="goSs">
							<el-option v-for="item in funList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="societyXlTwo">
						<el-select v-model="city_id" :placeholder="$t('手机号码')" multiple @change="goSs">
							<el-option v-for="item in cityList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="societyList">
					<div class="societyListFor" v-for="(item,index) in recruitList" :key="index"
						@click="goDetail(item)">
						<div class="societyListForOne">
							<div class="jiBox" v-if="item.is_urgent==1">
								<span class="ji">{{$t('请输入手机号码')}}</span>
							</div>
							{{item.name}}
						</div>
						<div class="societyListForTwo">
							{{item.city_name}}｜{{item.function_type_name}}｜{{item.create_time}}{{item.is_my==1?' | 面议':' | '+(item.min_salary||'--')+'~'+(item.max_salary||'--')+'*'+(item.work_month||'--')}}{{item.education?" | "+item.education:''}}
						</div>
					</div>
				</div>
				<div class="newsPagination ">
					<el-pagination :page-size="limit" layout="prev, pager, next" :total="allNum"
						@current-change="goPagin">
					</el-pagination>
					<!-- <div class="newsPaginationFor" v-for="(item,index) in allArr" :key="index" @click="goPagin(item)">
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
							v-if="index==0">
							{{$t('邮箱')}}
						</div>
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
							v-else-if="index==(allArr - 1)">
							{{$t('邮箱')}}
						</div>
						<div class="newsPaginationForOne" :class="page==item?'newsPaginationFour':'newsPaginationTwo'"
							v-else>
							{{item}}
						</div>
					</div> -->
				</div>

				<div v-if="!headerShow" @click="handelClick"
					style="width: 40px;height: 40px;border-radius: 50%;background-color: #fff;position: fixed;bottom: 150px;right: 40px;z-index: 9999;display: flex;align-items: center;justify-content: center;box-shadow: 0 0 6px rgba(0,0,0,.12);">
					<img src="../../assets/index/new.png" style="width: 30px;height: 30px;" alt="">
				</div>



				<div class="zxzw">
					<div class="zxzwTil">{{$t('分享')}}</div>
					<div class="zxzwList">
						<div class="zxzwListFor" v-for="(item,index) in newPosition" :key="index"
							@click="goDetail(item)">
							{{item.name}}
						</div>
					</div>
				</div>
				<!-- <div class="societyTilTwo">
					{{$t('投递')}}
				</div> -->
				<div class="societyTilTwoCen">
					{{$t('HR联系方式')}}：{{email}}
				</div>
			</div>

		</template>


	</div>
</template>

<script>
	import {
		get_new_position,
		get_recruit_list,
		get_function_type,
		get_city
	} from "@/api/recruit.js"
	import {
		get_config
	} from "@/api/config.js"
	export default {
		components: {

		},
		data() {
			return {
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value1: '',
				value: '',
				allNum: 0,
				limit: 10,
				page: 1,
				newPosition: [],
				recruitList: [],
				email: 'hr@aohua.com',
				keywords: '',
				function_type: [],
				city_id: [],
				cityList: [],
				funList: [],
				newWork: false
			}
		},
		computed: {
			allArr() {
				return Math.ceil(this.allNum / this.limit);
			}
		},
		mounted() {
			this.getList();
			this.getPosition();
			this.getFunType();
			this.getCity();
			this.getEmail();
		},
		methods: {
			handelClick() {
				this.newWork = !this.newWork
				let dom = document.querySelector('.zxzw')
				dom.style.transition = 'all .5s linear 0s';
				if (this.newWork) {
					dom.style.setProperty('right', '40px', 'important')
				} else {
					dom.style.setProperty('right', '-280px', 'important')
				}
			},
			goClear() {
				this.page = 1;
				this.keywords = '';
				this.function_type = [];
				this.city_id = []
				this.getList();
			},
			goSs() {
				this.page = 1;
				console.log(this.function_type)
				this.getList();
			},
			goPagin(e) {
				this.page = e;
				this.getList();
			},
			goDetail(item) {
				this.$router.push({
					push: '/recruitSocietyDetail',
					name: 'recruitSocietyDetail',
					query: {
						id: item.id
					}
				})

			},
			getList() {
				let data = {
					page: this.page,
					limit: this.limit,
					type: 1,
					keywords: this.keywords,
					function_type: this.function_type,
					city_id: this.city_id
				}
				get_recruit_list(data).then(res => {
					console.log(res)
					this.recruitList = res.data.list;
					this.allNum = res.data.count
				}).catch(err => {
					console.log(err)
				})
			},
			getPosition() {
				let data = {}
				get_new_position(data).then(res => {
					console.log(res)
					this.newPosition = res.data.list;
				}).catch(err => {
					console.log(err)
				})
			},
			// 获取HR联系方式
			getEmail() {
				let data = {}
				get_config(data).then(res => {
					console.log(res)
					this.email = res.data.hr_contact_email
				}).catch(err => {
					console.log(err)
				})
			},
			// 获取职能类型
			getFunType() {
				let data = {
					type: 1
				}
				get_function_type(data).then(res => {
					console.log(res)
					this.funList = res.data.list;
				}).catch(err => {
					console.log(err)
				})
			},
			// 获取城市
			getCity() {
				let data = {
					type: 1
				}
				get_city(data).then(res => {
					console.log(res)
					this.cityList = res.data.list;
				}).catch(err => {
					console.log(err)
				})
			},
			goDetail(item) {
				this.$router.push({
					push: '/recruitSocietyDetail',
					name: 'recruitSocietyDetail',
					query: {
						id: item.id
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.newsPagination {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 160px;
		padding-top: 50px;
		width: 1200px;
		margin: 0 auto;

		.newsPaginationFor:not(:last-child) {
			margin-right: 54px;
		}

		.newsPaginationFor {
			.newsPaginationForOne {
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				
				font-weight: 400;
				cursor: pointer;
			}

			.newsPaginationOne {
				background-color: #f4f4f4;
				width: 50px;
				height: 50px;
				font-size: 20px;
				color: #ACACAC;
			}

			.newsPaginationTwo {
				width: 20px;
				height: 20px;
				background-color: #f4f4f4;
				font-size: 17px;
				
				font-weight: 400;
				color: #ACACAC;
			}

			.newsPaginationThree {
				width: 50px;
				height: 50px;
				background-color: #848484;
				font-size: 20px;
				color: #FFFFFF;
			}

			.newsPaginationFour {
				width: 20px;
				height: 20px;
				background-color: #848484;
				font-size: 17px;
				
				font-weight: 400;
				color: #fff;
			}
		}
	}

	.society {
		width: 1000px;
		margin: 0 auto;
		padding-right: 200px;
		position: relative;

		.zxzw {
			position: absolute;
			top: 300px;
			right: -100px;
			width: 200px;
			padding: 21px 26px;
			background: #FFFFFF;
			box-shadow: 0px 1px 8px 0px rgba(39, 39, 39, 0.2);
			border-radius: 10px;

			.zxzwTil {
				font-size: 18px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom: 22px;

			}

			.zxzwList {
				.zxzwListFor {
					margin-bottom: 16px;
					font-size: 18px;
					
					font-weight: 400;
					color: #000000;
					cursor: pointer;
				}
			}
		}

		.societyTil {
			padding-top: 82px;
			padding-bottom: 42px;
			font-size: 36px;
			
			font-weight: bold;
			color: #000000;
		}

		.societyAll {
			margin-bottom: 71px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.societyAllLeft {
				font-size: 24px;
				
				font-weight: 400;
				color: #000000;
			}

			.societyAllRight {
				font-size: 24px;
				
				font-weight: 300;
				color: #737373;
				display: flex;
				align-items: center;
			}
		}

		.societySs {
			background: rgba(239, 239, 239, 0);
			border: 2px solid #222222;
			border-radius: 10px;
			display: flex;
			height: 50px;
			margin-bottom: 31px;

			.societySsOne {
				flex: 1;
				height: 50px;
				padding-left: 30px;

				input {
					width: 100%;
					border: none;
					outline: none;
					background: none;
					height: 50px;
					font-size: 24px;
					
					font-weight: 300;
				}

				input::placeholder {
					color: #DFDFDF;
				}
			}

			.societySsTwo {
				border-radius: 0 10px 10px 0;
				background: #343434;
				width: 212px;
				height: 50px;
				font-size: 24px;
				
				font-weight: 500;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: -2px;
				cursor: pointer;
			}
		}

		.societyXl {
			display: flex;
			margin-bottom: 88px;

			.societyXlOne {
				margin-right: 15px;
			}
		}

		.societyList {
			padding-top: 73px;
			border-top: 2px solid #E5E5E5;

			.societyListFor {
				background: rgba(239, 239, 239, 0);
				border: 2px solid #E5E5E5;
				border-radius: 10px;
				margin-bottom: 30px;
				padding: 30px 38px;
				cursor: pointer;

				.societyListForOne {
					font-size: 24px;
					
					font-weight: bold;
					color: #000000;
					margin-bottom: 13px;
					display: flex;

					.jiBox {
						width: 20px;
						position: relative;
						margin-right: 8px;

						.ji {
							position: relative;
							background-color: #ff6b6b;
							width: 20px;
							height: 20px;
							font-size: 12px;
							line-height: 20px;
							border-radius: 4px;
							color: #fff;
							position: absolute;
							top: 6px;
							display: inline-block;
							text-align: center;
						}
					}

				}

				.societyListForTwo {
					font-size: 18px;
					
					font-weight: 400;
					color: #666666;
				}
			}
		}

		.societyTilTwo {
			font-size: 36px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;

		}

		.societyTilTwoCen {
			font-size: 24px;
			
			font-weight: 500;
			color: #B3B3B3;
			padding-bottom: 192px;
		}
	}
</style>
<style lang="scss">
	.el-pagination {
		display: flex;
	}

	.el-pager .number {
		width: 25px !important;
		height: 25px !important;
		line-height: 25px;
		min-width: 0;
	}

	.el-pager .active {
		color: #fff !important;
		background: #848484 !important;
		border-radius: 100%;

	}


	@media screen and (max-width:1200px) {
		.society {
			width: 100% !important;
			padding: 0 30px !important;
			box-sizing: border-box !important;

			.societyTil {
				width: 100% !important;
				font-size: 28px !important;
				padding: 10px 0 20px !important;
			}

			.societyAll {
				width: 100% !important;
				display: block !important;
				margin-bottom: 30px !important;

				.societyAllLeft {
					font-size: 22px !important;
					margin-bottom: 10px !important;
				}

				.societyAllRight {
					width: 100%;
					font-size: 20px !important;

					.societyAllRightInfo {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100% !important;
					}

					.clearBtn {
						display: flex;
						align-items: center;
					}
				}
			}

			.societySs {
				width: 100% !important;

				.societySsOne {
					input {
						font-size: 18px !important;
					}
				}

				.societySsTwo {
					width: 30% !important;
					font-size: 18px !important;
				}
			}

			.societyXl {
				width: 100% !important;
				margin-bottom: 30px !important;
			}

			.societyList {
				width: 100% !important;
				padding-top: 10px !important;
				border-top: 0 !important;

				.societyListFor {
					padding: 20px 20px !important;

					.societyListForOne {
						font-size: 20px !important;
					}

					.societyListForTwo {
						font-size: 16px !important;
					}
				}
			}

			.newsPagination {
				width: 100% !important;
				padding: 10px 0 20px !important;
				box-sizing: border-box;
			}

			.zxzw {
				position: fixed !important;
				top: unset !important;
				right: -280px !important;
				bottom: 200px !important;
				z-index: 9999 !important;
				height: auto !important;
				animation: all 1s;
			}

			.societyTilTwoCen {
				width: 100% !important;
				padding: 10px 0 30px 0 !important;
				font-size: 20px !important;
				text-align: center;
			}
		}
	}
</style>